// extracted by mini-css-extract-plugin
export default {"profile":"BodyDogProfile_profile__jcodr","img":"BodyDogProfile_img__EEKq2","caption":"BodyDogProfile_caption__xTbX9"};